module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "synopsis"
    }
  }, [_c('h1', [_vm._v("Synopsis")]), _vm._v(" "), _c('p', [_vm._v("Book Two in the Parvon Zin series.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Earth is blissfully unaware they have been under constant surveillance from the Anunnaki based on the dark side of the moon for aeons. The government cover-ups from the mid-forties on to the present day grey aliens. Abductions. The moon being hollow…all the kooky conspiracy theories. Well, it’s all true, and the people of Earth, or as the creators of modern man, the Anunnaki named it Thera Three, are not amused at what has become of their creations. Where is the gold? Their slaves should have had mountains of the stuff stockpiled for their master’s return; we did say we would be back…Well, we are here.")]), _vm._v(" "), _c('p', [_vm._v("Can Zin and Ohna save the Earth from becoming another mined-out husk as its slaves are worked to death by the heartless Anunnaki?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025fec64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0